var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseupButtonArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "22px",
    viewBox: "0 0 11 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stroke 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STENI-pattern-generator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pick-pattern-menu-open-SANDSTONE-button-hover",
    transform: "translate(-1451.000000, -169.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_1_white-copy",
    transform: "translate(1430.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    transform: "translate(26.666667, 10.000000) rotate(-180.000000) translate(-26.666667, -10.000000) ",
    points: "32 20 21.3333333 10 32 0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseupButtonArrowIcon);
export default __webpack_public_path__ + "static/media/closeup-button-arrow-icon.b293adf14558627c681ec92153d69b78.svg";
export { ForwardRef as ReactComponent };